import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Criterio } from 'src/app/_models/meta';
import { Autoevaluacion } from '../autoevaluacion';

@Component({
  selector: 'app-autoevaluacion-criterio',
  standalone: false,
  templateUrl: './autoevaluacion-criterio.component.html',
  styleUrls: ['./autoevaluacion-criterio.component.scss', '../autoevaluacion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AutoevaluacionCriterioComponent implements OnInit {

  @Input()
  criterio: Criterio;

  @Input()
  eventoMateriaId: number;

  @Input()
  autoevaluacion$: Observable<Autoevaluacion>;

  @Input()
  autoevaluacion: Autoevaluacion;

  nivel: number;

  constructor() { }

  ngOnInit(): void {
    this.setNivel();
  }

  setNivel() {
    this.nivel = 0;
    if (this.autoevaluacion && this.autoevaluacion.criterioNivel) {
      const indexCriterioNiveles = this.autoevaluacion.criterioNivel.findIndex(item => item.criterioParentID === this.criterio.id);
      if (indexCriterioNiveles > -1) {
        const indexNivelSelecionado = this.criterio.niveles.findIndex(item =>
          item.id === this.autoevaluacion.criterioNivel[indexCriterioNiveles].nivel);
        this.nivel = indexNivelSelecionado > -1 ? indexNivelSelecionado : 0;
      }
    }
  }

}
